var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      !_vm.loading
        ? [
            _c("g-g-app-header", [_vm._v(" WordPress Setup Information ")]),
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  {
                    staticClass: "pb-0",
                    attrs: {
                      cols: "12",
                      md: "3"
                    }
                  },
                  [
                    _c("gg-select", {
                      attrs: {
                        label: "URL Protocol",
                        items: _vm.softprotoList,
                        "item-text": "text",
                        "item-value": "value"
                      },
                      model: {
                        value: _vm.softproto,
                        callback: function callback($$v) {
                          _vm.softproto = $$v
                        },
                        expression: "softproto"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "pb-0",
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c("gg-input-label", [_vm._v("Domain")]),
                    _c("domain-select", {
                      attrs: {
                        flat: "",
                        "no-label": "",
                        "hide-details": "",
                        outlined: "",
                        solo: ""
                      },
                      on: {
                        "domain-type-selected": _vm.setDomainType
                      },
                      model: {
                        value: _vm.softdomain,
                        callback: function callback($$v) {
                          _vm.softdomain = $$v
                        },
                        expression: "softdomain"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "pb-0",
                    attrs: {
                      cols: "12",
                      md: "3"
                    }
                  },
                  [
                    _c("gg-select", {
                      attrs: {
                        label: "Language",
                        items: _vm.languages,
                        loading: _vm.loadingInfo,
                        "item-value": "value",
                        "item-text": "label"
                      },
                      model: {
                        value: _vm.language,
                        callback: function callback($$v) {
                          _vm.language = $$v
                        },
                        expression: "language"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c("gg-select", {
                      attrs: {
                        label: "Installation Path",
                        items: _vm.customDirOptions,
                        "item-value": "value",
                        "item-text": "label"
                      },
                      model: {
                        value: _vm.customDir,
                        callback: function callback($$v) {
                          _vm.customDir = $$v
                        },
                        expression: "customDir"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _vm.customDir
                      ? _c("gg-text-field", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            label: "Specify Directory",
                            name: "Directory",
                            "data-vv-as": "Directory",
                            "error-messages": _vm.errors.collect("Directory")
                          },
                          model: {
                            value: _vm.softdirectory,
                            callback: function callback($$v) {
                              _vm.softdirectory = $$v
                            },
                            expression: "softdirectory"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c("gg-text-field", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|excluded:admin,root,administrator",
                          expression:
                            "'required|excluded:admin,root,administrator'"
                        }
                      ],
                      attrs: {
                        label: "Admin Username",
                        name: "admin_username",
                        "data-vv-as": "Admin Username",
                        "error-messages": _vm.errors.collect("admin_username")
                      },
                      model: {
                        value: _vm.admin_username,
                        callback: function callback($$v) {
                          _vm.admin_username = $$v
                        },
                        expression: "admin_username"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c("compact-password", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:8",
                          expression: "'required|min:8'"
                        }
                      ],
                      attrs: {
                        outlined: "",
                        charset:
                          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMOPRSTUVWXYZ0123456789_",
                        autocomplete: "new-password",
                        label: "Admin Password",
                        "data-vv-name": "password_adm",
                        "data-vv-as": "Admin Password",
                        "error-messages": _vm.errors.collect("password_adm"),
                        "with-generator": ""
                      },
                      model: {
                        value: _vm.admin_pass,
                        callback: function callback($$v) {
                          _vm.admin_pass = $$v
                        },
                        expression: "admin_pass"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      md: "6"
                    }
                  },
                  [
                    _c("gg-text-field", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|email",
                          expression: "'required|email'"
                        }
                      ],
                      attrs: {
                        label: "Admin Email",
                        name: "Admin Email",
                        "data-vv-as": "Admin Email",
                        "error-messages": _vm.errors.collect("Admin Email")
                      },
                      model: {
                        value: _vm.admin_email,
                        callback: function callback($$v) {
                          _vm.admin_email = $$v
                        },
                        expression: "admin_email"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12"
                    }
                  },
                  [
                    _vm._v(
                      " Your website will be powered by LiteSpeed & LSCache for WordPress for super fast performance. "
                    ),
                    _c(
                      "a",
                      {
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                            _vm.showLitespeed = true
                          }
                        }
                      },
                      [_vm._v("More Info")]
                    )
                  ]
                ),
                _c("litespeed-info", {
                  attrs: {
                    value: _vm.showLitespeed
                  },
                  on: {
                    "update:value": function updateValue($event) {
                      _vm.showLitespeed = $event
                    }
                  }
                }),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12"
                    }
                  },
                  [
                    _c(
                      "gg-btn",
                      {
                        staticClass: "mr-3",
                        attrs: {
                          loading: _vm.loading
                        },
                        on: {
                          click: _vm.install
                        }
                      },
                      [_vm._v("Install WordPress")]
                    ),
                    _c(
                      "gg-btn",
                      {
                        attrs: {
                          secondary: "",
                          disabled: _vm.loading
                        },
                        on: {
                          click: _vm.goBack
                        }
                      },
                      [_vm._v("Go Back")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm.loading
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass:
                    "py-0 d-flex flex-column justify-center align-center",
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "h4 mt-4"
                    },
                    [_vm._v("Starting something Amazing")]
                  ),
                  _c("v-progress-circular", {
                    attrs: {
                      indeterminate: "",
                      size: "64",
                      width: "6",
                      color: "primary"
                    }
                  }),
                  _c(
                    "p",
                    {
                      staticClass: "pt-4 h4"
                    },
                    [_vm._v("This will only take a moment!")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("installation-exists-modal", {
        attrs: {
          softdomain: _vm.softdomain,
          opened: _vm.showInstallationExists
        },
        on: {
          close: function close($event) {
            _vm.showInstallationExists = false
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }